import { ref } from 'vue';

const theme = ref(localStorage.getItem('theme') || 'light');

const applyTheme = (newTheme) => {
  const root = document.documentElement;
  const isDark = newTheme === 'dark';

  // Remove both classes first
  root.classList.remove('dark-mode', 'light-mode');

  if (isDark) {
    root.classList.add('dark-mode');
  } else {
    root.classList.add('light-mode');
  }

  // Keep Bootstrap 5.3+ components (tables, forms, cards) in sync
  root.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');

  theme.value = newTheme;
  localStorage.setItem('theme', newTheme);
};

const toggleTheme = () => {
  const newTheme = theme.value === 'light' ? 'dark' : 'light';
  applyTheme(newTheme);
};

const setTheme = (newTheme) => {
  if (['light', 'dark'].includes(newTheme)) {
    applyTheme(newTheme);
  }
};

// Initialize theme immediately when module loads
if (typeof document !== 'undefined') {
  applyTheme(theme.value);
}

export function useTheme() {
  return {
    theme,
    toggleTheme,
    setTheme,
  };
}

